import { Component } from 'react';
import { isGranted } from 'helpers/helpers';
import { ROLE_CREATE_NOTE } from 'helpers/roles';
import { put } from 'helpers/apiHelpers';
import ModalButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Close from '@material-ui/icons/Close';
import { toast } from 'react-toastify';

import { orderStyles } from './styles';

class NotesEditModal extends Component {
  state = {
    data: {},
    hasChanged: false,
  };

  componentDidMount() {
    this.setState({ data: this.props.editModalData });
  }

  // eslint-disable-next-line consistent-return -- FIXME
  addNote = e => {
    const { t } = this.props;
    if (!this.state.data.content) {
      return toast.error(t('errors.contentRequired'));
    }

    e.preventDefault();
    put(this.state.data['@id'], {
      key: this.state.data.key,
      content: this.state.data.content,
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(() => {
      this.setState({ data: {} });
      this.closeModal();
      toast.success(t('success.noteUpdate'));
    });
  };

  closeModal = () => {
    this.props.setEditModalStatus(false);
    this.props.getNotesAndCloseModal();
  };

  render() {
    const { classes, t } = this.props;

    return (
      <Dialog
        maxWidth="lg"
        fullWidth={false}
        open={this.props.editModalStatus}
        onClose={() => this.closeModal()}
      >
        <DialogContent>
          <ModalButton
            style={orderStyles.closeButton}
            color="transparent"
            justIcon={true}
            round={true}
            onClick={() => this.closeModal()}
          >
            <Close />
          </ModalButton>
          <GridContainer>
            {isGranted(ROLE_CREATE_NOTE) && (
              <GridItem md={12}>
                <div style={{ marginLeft: '5px', ...orderStyles.box }}>
                  <b>{t('notes.editNote', 'Edycja notatki')}</b>
                  <FormTextInput
                    multiline={true}
                    label={t('notes.noteContent', 'Treść notatki')}
                    classes={classes}
                    name="phone"
                    value={this.state.data.content}
                    handleChange={ev => {
                      const newValue = ev.target.value;
                      this.setState(prevState => ({
                        ...prevState,
                        hasChanged: true,
                        data: {
                          ...prevState.data,
                          content: newValue,
                        },
                      }));
                    }}
                    inputSize={12}
                    maxLength={400}
                  />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ModalButton
                      color="primary"
                      disabled={!this.state.hasChanged}
                      onClick={ev => this.addNote(ev)}
                    >
                      {/* eslint-disable-next-line no-negated-condition -- FIXME */}
                      {!this.state.hasChanged
                        ? t('cmmon.noChangesApplied', 'Nie dokonano zmian')
                        : t('common.saveChanges', 'Zapisz zmiany')}
                    </ModalButton>
                  </div>
                </div>
              </GridItem>
            )}
          </GridContainer>
        </DialogContent>
      </Dialog>
    );
  }
}

export default NotesEditModal;
